export default __webpack_public_path__ + "static/media/icon-bank-wire.b7beabce.svg";